export default {
  Community: {
    editingCase: {
      titleTextareaPlaceholder: "Істі сипаттаңыз немесе сұрақ қойыңыз",
      sybmolCount: "Таңбалар саны {min} - ден {max} - ға дейін болуы керек",
      wordsCount: "Сөздердің саны {min} - ден {max} - ге дейін болуы керек",
      mobiledocPlaceholder:
        "Науқасты тексеру деректері туралы толығырақ айтып беріңізші",
      mobiledocLabel: "Емтихан деректері",
      tags: "Тегтер",
      editCase: "Істі өңдеу",
      anamnesisPlaceholder:
        "Науқастың ауру тарихы туралы толығырақ айтып беріңізші",
      treatmentPlaceholder: "Науқасты емдеу туралы толығырақ айтып беріңізші",
      caseNotesPlaceholder: "Іс туралы толығырақ айтып беріңізші",
      questionNotesPlaceholder: "Сұрақ туралы толығырақ айтып беріңізші",
      addImage: "Суретті тіркеңіз",
      anamnesis: "Анамнез",
      treatment: "Емдеу",
      notes: "Қосу",
    },
    uploader: {
      case: {
        title: "Істі қосыңыз",
        description: "Өз тәжірибеңізден қызықты жағдайлармен бөлісіңіз",
      },
      question: {
        title: "Сұрақ қою",
        description:
          'Егер Сіз "Сұрақты"таңдасаңыз, пайдаланушылар тезірек жауап береді.',
      },
    },
    title: "Қауымдастық",
    description:
      "Клиникалық жағдайлар бойынша дәрігерлер арасындағы білім алмасу",
    all_cases: "Барлық кейстер",
    my_cases: "Менің кейстерім",
    case: {
      shareLink: {
        1: "Кейсті қараңыз",
        2: "Платформада “" + process.env.VUE_APP_INSTALL_NAME + "”:",
      },
    },
    noCasesLang: {
      1: "Осы тілде жарияланған жағдайлар әлі жоқ",
      2: "DICOM зерттемені бөлісетін және әріптестердің пікірлерін алатын бірінші болыңыз!",
    },
    filter: {
      status: {
        placeholder: "Жағдайларды сұрыптау",
        values: {
          popular: "Алдымен танымалдар",
          actual: "Алдымен жаңалар",
        },
        options: {
          base: "Алдымен көрсету",
          popular: "Танымал",
          actual: "Жаңа",
        },
      },
      modality: {
        placeholder: "Модальдік",
      },
      bodypart: {
        placeholder: "Зерттеу аймағы",
      },
      sex: {
        placeholder: "Жыныс",
        values: {
          M: "Ер",
          F: "Әйел",
        },
      },
    },
  },
  h1_community: "Дәрігерлер қауымдастығы",
};
